import {Group} from 'src/design/atoms/Group';
import {Text} from 'src/design/atoms/Text';
import {UnstyledButton} from 'src/design/atoms/UnstyledButton';
import {spotlight} from '@mantine/spotlight';
import {IconSearch} from '@tabler/icons-react';
import React from 'react';
import classes from './GlobalSearchTrigger.module.css';

export const GlobalSearchTrigger: React.FC = () => {
  return (
    <UnstyledButton
      onClick={() => spotlight.open()}
      className={classes.trigger}
      aria-label="Open global search">
      <Group gap="xs" wrap="nowrap">
        <IconSearch size={16} className={classes.icon} />
        <Text size="sm" c="dimmed">
          Search...
        </Text>
      </Group>
      <Text size="xs" c="dimmed">
        Ctrl + K
      </Text>
    </UnstyledButton>
  );
};
